import type { FormEvent, ReactNode } from "react";
import { MapPin } from "lucide-react";
import type { PublicMapArea } from "@natural/public-contract";
import { relationLabels, type OrganizationDetail } from "../../account";

type OrganizationAreasPageProps = {
  areas: PublicMapArea[];
  canEdit: boolean;
  capacityAvailable: boolean;
  capacityLocked: ReactNode;
  data: Pick<OrganizationDetail, "areas" | "onboarding">;
  onboardingLocked: ReactNode;
  onboardingBlocked: boolean;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
};

export function OrganizationAreasPage({
  areas,
  canEdit,
  capacityAvailable,
  capacityLocked,
  data,
  onboardingLocked,
  onboardingBlocked,
  onSubmit,
}: OrganizationAreasPageProps) {
  return (
    <section className="account-panel workspace-section">
      <div className="workspace-section-heading">
        <div>
          <span className="eyebrow">Core-alueet</span>
          <h2>Vastuut ja kattavuus</h2>
          <p>
            Organisaatio liitetään olemassa olevaan julkaistuun alueeseen.
            Platform varmentaa suhteen ennen Core-käyttöä.
          </p>
        </div>
        <MapPin />
      </div>
      {data.areas.length ? (
        <div className="organization-list">
          {data.areas.map((area, index) => (
            <article key={String(area.id ?? index)}>
              <MapPin />
              <div>
                <b>
                  {areas.find((item) => item.id === area.core_area_id)?.name ??
                    String(area.core_area_id)}
                </b>
                <span>
                  {relationLabels[String(area.relationship)] ?? String(area.relationship)} ·{" "}
                  {area.status === "verified" ? "varmennettu" : "odottaa varmennusta"}
                </span>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="account-empty compact">
          <MapPin />
          <p>Aluekytkentöjä ei ole vielä.</p>
        </div>
      )}
      {!capacityAvailable ? (
        capacityLocked
      ) : onboardingBlocked ? (
        onboardingLocked
      ) : canEdit ? (
        <form className="inline-account-form workspace-form" onSubmit={onSubmit}>
          <label>
            Julkaistu Core-alue
            <select name="coreAreaId" required defaultValue="">
              <option value="" disabled>Valitse alue</option>
              {areas.map((area) => <option value={area.id} key={area.id}>{area.name}</option>)}
            </select>
          </label>
          <label>
            Organisaation suhde
            <select
              name="relationship"
              defaultValue={data.onboarding.goals.includes("permit_issuing") ? "permit_issuer" : "manager"}
            >
              {Object.entries(relationLabels).map(([value, label]) => (
                <option value={value} key={value}>{label}</option>
              ))}
            </select>
          </label>
          <div><button disabled={!areas.length}>Lähetä varmennettavaksi</button></div>
        </form>
      ) : null}
    </section>
  );
}
